// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import i18next from "i18next";
import { createI18nStore } from "svelte-i18next";

import ar from "../public/locales/ar/translation.json";
import cs from "../public/locales/cs/translation.json";
import de from "../public/locales/de/translation.json";
import el from "../public/locales/el/translation.json";
import en from "../public/locales/en/translation.json";
import es from "../public/locales/es/translation.json";
import fr from "../public/locales/fr/translation.json";
import hi from "../public/locales/hi/translation.json";
import it from "../public/locales/it/translation.json";
import ja from "../public/locales/ja/translation.json";
import nl from "../public/locales/nl/translation.json";
import no from "../public/locales/no/translation.json";
import pl from "../public/locales/pl/translation.json";
import pt from "../public/locales/pt/translation.json";
import ru from "../public/locales/ru/translation.json";
import zh from "../public/locales/zh/translation.json";
// To add more languages, import them here

const savedLanguage = localStorage.getItem("language") || "de";

i18next.init({
	lng: savedLanguage, // Default language will be german - sorry dear english speaking collegues ♥
	fallbackLng: "de",
	resources: {
		de: { translation: de },
		en: { translation: en },
		es: { translation: es },
		ar: { translation: ar },
		cs: { translation: cs },
		el: { translation: el },
		fr: { translation: fr },
		hi: { translation: hi },
		it: { translation: it },
		ja: { translation: ja },
		nl: { translation: nl },
		no: { translation: no },
		pl: { translation: pl },
		pt: { translation: pt },
		ru: { translation: ru },
		zh: { translation: zh },
		// Add other languages here
	},
	interpolation: {
		escapeValue: false,
	},
});

const i18n = createI18nStore(i18next);

export default i18n;
